const normalize = (s: string) =>
  s.trim().toLowerCase().replace(/\s+/g, ' ').normalize('NFC');

export const isSameCategoryName = (a: string, b: string) =>
  normalize(a) === normalize(b);
